import {
  GET_LIST_QUANLYTHUCHIHOPDONG,
  GET_LIST_QUANLYTHUCHIHOPDONG_SUCCESS,
  GET_LIST_QUANLYTHUCHIHOPDONG_FAILURE,
  UPDATE_SEARCHTDATA_QUANLYTHUCHIHOPDONG,
} from "./actionTypes";

export const getListQuanLyThuChiHopDong = (dataSearch) => ({
  type: GET_LIST_QUANLYTHUCHIHOPDONG,
  dataSearch,
});
export const getListQuanLyThuChiHopDongSuccess = (data) => ({
  type: GET_LIST_QUANLYTHUCHIHOPDONG_SUCCESS,
  payload: data,
});
export const getListQuanLyThuChiHopDongFailure = (dataSearch) => ({
  type: GET_LIST_QUANLYTHUCHIHOPDONG_FAILURE,
});
export const updateDataSearch = (data) => ({
  type: UPDATE_SEARCHTDATA_QUANLYTHUCHIHOPDONG,
  payload: data,
});
